import React, {useEffect, useState} from "react";
import associateServices from "../../../../services";
import Big from "big.js";
import moment from "moment/moment";
import Loading from "../../../../components/loading";

const ActiveRaces = props => {

    const {username} = props
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        setLoading(true)
        associateServices.getActiveRaces({
            username
        }).then(res => {
            // setData()
            setLoading(false)
            setData((res?.data))
        })
    }, [])
    return (

        loading ? <Loading/> :
            data?.map(race => (
                <div className="col-12" key={race.id}>
                    <div className="race">
                        <p className="race__position">#</p>
                        <h6 className="race__title">{race?.key}</h6>
                        <p className="race__prize">$ {Big(race?.prize || 0).toFixed(2)}</p>
                        <span className="race__date">{moment.unix(race?.end).format('MMM Do YY')}</span>

                    </div>
                </div>
            ))
    )

}

export default ActiveRaces
